'use strict';

angular.module('msCore').constant('nameRegex', /^[\s\w'ñáéíóúüÁÉÍÓÚÑÜ¿¡=_\-\!\?\.\$€]*$/);